namespace Serenity.UI {   
    export enum FormMode {
        Initial = 0,
        New = 1,
        Edit = 2,
        View = 3,
        Deleted = 4
    }
}